import styled from '@emotion/styled';
import { Section } from './Section';
import { ITextSectionEntry } from '../../../../contentful';
import { MarkdownRenderContextProvider } from '../../../../components/common/markdown';
import { Markdown } from '../../../../ui';

export interface ITextSectionsProps {
	id: string;
	section: ITextSectionEntry;
}

export function TextSection({ id, section }: ITextSectionsProps) {
	return (
		<StyledSection id={id}>
			<MarkdownRenderContextProvider>
				<Markdown source={section.fields.body} />
			</MarkdownRenderContextProvider>
		</StyledSection>
	);
}

const StyledSection = styled(Section)`
	p {
		white-space: pre-line;
	}
`;
